module.exports = "pegasus/assets/tech/basic_1/1.png";